<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const servicesRechercheOptions = [
        `Stratégie de communication & conseil`,
        `Création de contenus (textes, photos, vidéos)`,
        `Publicité & marketing digital (SEO, SEA, réseaux sociaux)`,
        `Identité visuelle & design graphique`,
        `Événementiel & relations publiques`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const objectifPrincipalOptions = [
        `Améliorer la notoriété de ma marque`,
        `Générer plus de prospects / ventes`,
        `Lancer un nouveau produit ou service`,
        `Fidéliser mes clients existants`,
        `Développer ma présence en ligne`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const secteurActiviteOptions = [
        `Commerce & distribution`,
        `Services aux entreprises`,
        `Industrie & construction`,
        `Santé & bien-être`,
        `Hôtellerie, restauration & tourisme`,
        `Autre (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.agencesCommunication.servicesRecherches}
        class=""
        let:field
        let:id
        label={`Quel type de services recherchez-vous ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={servicesRechercheOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.agencesCommunication.objectifPrincipal}
        class=""
        let:field
        let:id
        label={`Quel est l'objectif principal de votre projet ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={objectifPrincipalOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.agencesCommunication.secteurActivite}
        class=""
        let:field
        let:id
        label={`Dans quel secteur évolue votre activité ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[300px]:grid-cols-2 @[500px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={secteurActiviteOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
